export default function initAnims() {
	const animations = document.querySelectorAll('.animate');

	function checkAnims() {	
		animations.forEach(el => {
			if(!el.classList.contains('anim') && isInViewportTop(el)) {
				el.classList.add('anim');
			}
		});
	}

	checkAnims();

	window.addEventListener('scroll', () => {
		checkAnims();
	});
}